
export interface YouTubeTrack {
    id: string;
    ytId: string;
    label: string;
    credit: string;
}

export const YOUTUBE_TRACKS: YouTubeTrack[] = [
    { id: 'track_1', ytId: 'iXAd5894BPw', label: 'DSAudio 01', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_2', ytId: 'PKUEKu_TogQ', label: 'DSAudio 02', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_3', ytId: 'QrygX-4m5To', label: 'DSAudio 03', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_4', ytId: 'jdxSFWo-kkE', label: 'DSAudio 04', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_5', ytId: 'jsb2HCTGdVc', label: 'DSAudio 05', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_6', ytId: 'nb7GLtKEpLY', label: 'DSAudio 06', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_7', ytId: 'IXJclVeD4xQ', label: 'DSAudio 07', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_8', ytId: 'pU4kwPtD83I', label: 'DSAudio 08', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_9', ytId: 'IFFY-Xtvbcc', label: 'DSAudio 09', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_10', ytId: 'MdEtyH2Qhwc', label: 'DSAudio 10', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_11', ytId: 'oOub_FKxGHk', label: 'DSAudio 11', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_12', ytId: 'jckgH2-58kg', label: 'DSAudio 12', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_13', ytId: 'Hd012g6hpiU', label: 'DSAudio 13', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_14', ytId: 'z6Yrj2igI9s', label: 'DSAudio 14', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_15', ytId: 'PX8U-iB8YFc', label: 'DSAudio 15', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_16', ytId: '4ZFR2_WntH0', label: 'DSAudio 16', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_17', ytId: 'p8B0N5Jm3NI', label: 'DSAudio 17', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_18', ytId: 'GsB3mi4eb98', label: 'DSAudio 18', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_19', ytId: 'vThsTg5HQPY', label: 'DSAudio 19', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_20', ytId: 'W7xcyrt9GoY', label: 'DSAudio 20', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_21', ytId: 'zx6OtEbbi1M', label: 'DSAudio 21', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_22', ytId: 'RQ-Yxu4JZfI', label: 'DSAudio 22', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_23', ytId: 'CgVV97kHIiQ', label: 'DSAudio 23', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_24', ytId: 'Cr9ZMqUcfFI', label: 'DSAudio 24', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_25', ytId: 'w2sU1DY3xio', label: 'DSAudio 25', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_26', ytId: 'UGyo-8vnkYM', label: 'DSAudio 26', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_27', ytId: 'lCEIW7qswVw', label: 'DSAudio 27', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_28', ytId: 'VUQGtwLQPIU', label: 'DSAudio 28', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_29', ytId: 'fP9BHu0nmGM', label: 'DSAudio 29', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_30', ytId: '5BCtOCdaonw', label: 'DSAudio 30', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_31', ytId: '5EjqN8pEuQA', label: 'DSAudio 31', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_32', ytId: '4h7jLpVqAQY', label: 'DSAudio 32', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_33', ytId: '7bVZA9hCLbY', label: 'DSAudio 33', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_34', ytId: 'qrjz867-kOw', label: 'DSAudio 34', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_35', ytId: '5RgW1udANHU', label: 'DSAudio 35', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_36', ytId: '3tUt5q2m1sw', label: 'DSAudio 36', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_37', ytId: '4c34wEuVnsU', label: 'DSAudio 37', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_38', ytId: 'DV9B8igGAAI', label: 'DSAudio 38', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_39', ytId: 'Yi0d7Q6-jYI', label: 'DSAudio 39', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_40', ytId: 'AZzOXVhV-gc', label: 'DSAudio 40', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_41', ytId: '-kwxB8tZVb0', label: 'DSAudio 41', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_42', ytId: '3xWRI0nYLXg', label: 'DSAudio 42', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_43', ytId: 'Fu48LY6vkdk', label: 'DSAudio 43', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_44', ytId: '0hD8Zl9yhag', label: 'DSAudio 44', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_45', ytId: 'uSy6nHLPT4A', label: 'DSAudio 45', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_46', ytId: 'QmJbZCWNpF8', label: 'DSAudio 46', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_47', ytId: 'vh2hTkZNDZA', label: 'DSAudio 47', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_48', ytId: 'NpSUnGele3o', label: 'DSAudio 48', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_49', ytId: 'gMkyArDf4DM', label: 'DSAudio 49', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_50', ytId: 'uQzKmc58toY', label: 'DSAudio 50', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_51', ytId: 'nCtxmrldUcs', label: 'DSAudio 51', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_52', ytId: 'I5wEJ69NdiU', label: 'DSAudio 52', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_53', ytId: 'SaS465OvTRI', label: 'DSAudio 53', credit: 'ROMANOSV3 STUDIO' },
    { id: 'track_54', ytId: '6xuIchy-uF8', label: 'DSAudio 54', credit: 'ROMANOSV3 STUDIO' },
];
